export default "__VITE_ASSET__DqhyE9bm__"